import React from "react";
import PropTypes from "prop-types";
import "../styles/our-mission.css";

/**
 * OurMission
 *
 * Figma-aligned section with:
 * - Eyebrow (uppercase), title, intro paragraph (centered)
 * - Two-column row: values list (with dividers) + right image
 *
 * Props (all optional; sensible defaults provided from Figma):
 * - eyebrow: string (default: "THE AVENUE SCHOOL")
 * - title: string (default: "Our Mission")
 * - intro: string (default: Figma copy)
 * - values: string[] (default: Figma bullet lines)
 * - imageSrc: string (default placeholder 416x480)
 * - imageAlt: string (default: "Students")
 *
 * A11y:
 * - Heading order: <h2> for title, <h3> for "Our Values"
 * - Values rendered as semantic <ul><li>
 */
const OurMission = ({
  eyebrow = "THE AVENUE SCHOOL",
  title = "Our Mission",
  intro = "The Avenue School recognises the rights of all young people. We are committed to creating an inclusive and supportive learning environment, where young people feel safe and can engage in their educational journey with confidence.",
  values = [
    "Our school is safe for everyone.",
    "We celebrate diversity and are inclusive.",
    "We are open-minded, curious, and accepting.",
    "We demonstrate empathy, are compassionate, and act with kindness.",
    "We have respect for each other, our environment, and ourselves.",
    "We are honest and trusted by our people and our community.",
    "We nurture courage in all its forms.",
  ],
  imageSrc = "/media/gallery-3.jpg",
  imageAlt = "Students",
}) => {
  return (
    <section className="our-mission">
      <div className="our-mission__header">
        <p className="our-mission__eyebrow" aria-label={eyebrow}>
          {eyebrow}
        </p>
        <h2 className="our-mission__title">{title}</h2>
        <p className="our-mission__intro">{intro}</p>
      </div>

      <div className="our-mission__row">
        <div className="our-mission__col our-mission__col--left">
          <h3 className="our-mission__valuesTitle">Our Values</h3>
          <ul className="our-mission__valuesList" role="list">
            {values.map((v, i) => (
              <li key={i} className="our-mission__valueItem">
                {v}
              </li>
            ))}
          </ul>
        </div>

        <div className="our-mission__col our-mission__col--right">
          <img
            src={imageSrc}
            alt={imageAlt || ""}
            className="our-mission__image img-fluid"
          />
        </div>
      </div>
    </section>
  );
};

OurMission.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  intro: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default OurMission;
